import React, { useState } from 'react';
import { DatePicker, Select, Checkbox, Switch, Button } from 'antd';
import moment from 'moment';
import { CloseOutlined } from '@ant-design/icons';

const { Option } = Select;

const DateFilterComponent = ({ currentFilter, attributeFilters, setAttributeFilters }) => {
  const [dateRange, setDateRange] = useState([
    attributeFilters[currentFilter]?.fromDate || null,
    attributeFilters[currentFilter]?.toDate || null,
  ]);
  const [includeWithoutDate, setIncludeWithoutDate] = useState(
    attributeFilters[currentFilter]?.includeWithoutDate !== undefined
      ? attributeFilters[currentFilter]?.includeWithoutDate
      : true
  );
  const [applyToAllTabs, setApplyToAllTabs] = useState(false);
  const [includeWithDate, setIncludeWithDate] = useState(true);
  const [timePeriod, setTimePeriod] = useState('Manual selection');
  const handleDateRangeChange = (newDateRange) => {
    setDateRange(newDateRange);
    setAttributeFilters((prevFilters) => ({
      ...prevFilters,
      [currentFilter]: {
        ...prevFilters[currentFilter],
        fromDate: newDateRange[0],
        toDate: newDateRange[1],
      },
    }));
  };

  const handleIncludeWithoutDateChange = (event) => {
    setIncludeWithoutDate(event.target.checked);
    setAttributeFilters((prevFilters) => ({
      ...prevFilters,
      [currentFilter]: {
        ...prevFilters[currentFilter],
        includeWithoutDate: event.target.checked,
      },
    }));
  };

  const handleApplyToAllTabsChange = (checked) => {
    setApplyToAllTabs(checked);
    // Implement logic to apply the filter to all tabs if needed
  };

  const handleIncludeWithDateChange = (event) => {
    setIncludeWithDate(event.target.checked);
    // Implement logic to handle "Include items with a date" if needed
  };

  const handleTimePeriodChange = (value) => {
    setTimePeriod(value);
    if (value !== 'Manual selection') {
      const now = moment();
      let fromDate, toDate;
      switch (value) {
        case 'Last 7 days':
          fromDate = moment().subtract(7, 'days');
          toDate = now;
          break;
        case 'Last 30 days':
          fromDate = moment().subtract(30, 'days');
          toDate = now;
          break;
        case 'This month':
          fromDate = moment().startOf('month');
          toDate = now;
          break;
        case 'Last month':
          fromDate = moment().subtract(1, 'months').startOf('month');
          toDate = moment().startOf('month').subtract(1, 'days');
          break;
        default:
          break;
      }
      handleDateRangeChange([fromDate, toDate]);
    }
  };

  return (
    <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Apply filter to all tabs</span>
        <Switch checked={applyToAllTabs} onChange={handleApplyToAllTabsChange} />
      </div>

      <Checkbox checked={includeWithDate} onChange={handleIncludeWithDateChange}>
        (Select all)
      </Checkbox>

      <Checkbox checked={includeWithDate} onChange={handleIncludeWithDateChange}>
        Include items with a date
      </Checkbox>

      <div>
        <span>Select a time period</span>
        <Select value={timePeriod} onChange={handleTimePeriodChange} style={{ width: '100%' }}>
          <Option value="Manual selection">Manual selection</Option>
          <Option value="Last 7 days">Last 7 days</Option>
          <Option value="Last 30 days">Last 30 days</Option>
          <Option value="This month">This month</Option>
          <Option value="Last month">Last month</Option>
        </Select>
      </div>

      <div>
        <span>From</span>
        <DatePicker
          value={dateRange ? dateRange[0] : null}
          onChange={(date) => handleDateRangeChange([date, dateRange?.[1]])}
          disabled={timePeriod !== 'Manual selection'}
          style={{ width: '100%' }}
          placeholder="<no date selected>"
        />
      </div>

      <div>
        <span>To</span>
        <DatePicker
          value={dateRange ? dateRange[1] : null}
          onChange={(date) => handleDateRangeChange([dateRange?.[0], date])}
          disabled={timePeriod !== 'Manual selection'}
          style={{ width: '100%' }}
          placeholder="<no date selected>"
        />
      </div>

      <Checkbox checked={includeWithoutDate} onChange={handleIncludeWithoutDateChange}>
        Include items without a date
      </Checkbox>
    </div>
  );
};

export default DateFilterComponent;